export default function CROCardSection() {
    const croPoints = [
        {
            title: "Understand UAE Customers",
            description: "Understanding what UAE customers want and expect from your website."
        },
        {
            title: "Identify Friction Points",
            description: "Identifying friction points that stop them from buying or contacting you."
        },
        {
            title: "Build Trust & Improve UX",
            description: "Building trust through better design, faster pages, and clear messaging."
        }
    ];

    return (
        <div className="SectionCRO py-[20px] md:py-[10px] bg-[#f9f9f9]">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    What is Conversion Rate Optimization (CRO)?
                </h2>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    Conversion Rate Optimization, or CRO, is the process of improving your website so more visitors become customers. For UAE businesses, it’s about understanding your audience, how people in Dubai, Abu Dhabi, or Sharjah browse, buy, and behave online, and optimizing your site to meet their needs.<br />
                    <br />
                    <b>CRO focuses on:</b>
                </p>

            </div>

            {/* CRO Points Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {croPoints.map((point, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition ${index % 2 === 0
                            ? "bg-[#E42E35] text-white" // red card
                            : "bg-white text-[#151515]" // white card
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {point.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {point.description}
                        </p>
                    </div>
                ))}
            </div>

            {/* Summary */}
            <div className="text-center mt-12 max-w-2xl mx-auto">
                <p className="text-[#151515] text-[16px] md:text-[18px] font-semibold">
                    In short, CRO helps you turn your existing traffic into revenue without spending more on ads.
                </p>
            </div>
        </div>
    );
}
